module.exports = __webpack_public_path__ + "static/img/title-3.f7b8b5ca.svg";